const scope = "securityAttribute";
export default scope;
